import type { Tone } from "@/components/ui/tone";
import type { Infer } from "convex/values";
import type {
  confidenceLevelValidator,
  gradingSessionStatusValidator,
  qualityIssueSeverityValidator,
} from "@convex/schemas/gradingSessions.lib";

const CONFIDENCE_TONE: Record<Infer<typeof confidenceLevelValidator>, Tone> = {
  high: "success",
  medium: "warning",
  low: "destructive",
};

const SEVERITY_TONE: Record<Infer<typeof qualityIssueSeverityValidator>, Tone> = {
  minor: "info",
  moderate: "warning",
  severe: "destructive",
};

const SESSION_STATUS_TONE: Record<
  Infer<typeof gradingSessionStatusValidator>,
  Tone
> = {
  completed: "success",
  converted: "success",
  analyzing: "info",
  failed: "destructive",
};

export function confidenceTone(
  confidence: Infer<typeof confidenceLevelValidator>,
): Tone {
  return CONFIDENCE_TONE[confidence];
}

export function severityTone(
  severity: Infer<typeof qualityIssueSeverityValidator>,
): Tone {
  return SEVERITY_TONE[severity];
}

export function analysisSessionTone(
  status: Infer<typeof gradingSessionStatusValidator>,
): Tone {
  return SESSION_STATUS_TONE[status];
}
